<h2 mat-dialog-title>{{ 'CALLS.ADMIN.BOARD_PACK.DIALOG_TITLE' | translate }}</h2>
<mat-dialog-content>
  <p>{{ 'CALLS.ADMIN.BOARD_PACK.DIALOG_DESCRIPTION' | translate }}</p>
  <app-file-upload
    [acceptedFileTypes]="['pdf']"
    [maxPages]="MAX_BOARD_PACK_PAGES"
    maxPagesErrorMessage="CALLS.ADMIN.BOARD_PACK.MAX_PAGES_ERROR"
    [maxFileSizeBytes]="MAX_BOARD_PACK_FILE_SIZE_BYTES"
    maxFileSizeErrorMessage="CALLS.ADMIN.BOARD_PACK.MAX_FILE_SIZE_ERROR"
    type="board-pack"
    (fileChange)="onFileChange($event)"
    (pageLimitExceeded)="onPageLimitExceeded($event)"
    (fileSizeLimitExceeded)="onFileSizeLimitExceeded($event)"
  ></app-file-upload>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" (click)="submit()" [disabled]="isSubmitDisabled">
    {{ 'CALLS.ADMIN.BOARD_PACK.SUBMIT' | translate }}
  </button>
</mat-dialog-actions>
